import type { TFunction } from 'i18next';

import type { ExportColumnDefinition } from '@/components/molecules/ExportDataDropDown/DownloadOptions';

export function mapLiceReportExportColumns(
    columns: string[],
    t: TFunction
): ExportColumnDefinition[] {
    return columns.map((col) => {
        if (col === 'day.report_period') {
            return { name: col, header: t('export.reportPeriod') };
        }
        return col;
    });
}
